import DoAPICall from './DoAPICall'

//Create Client
    export async function createClientTopUps(userToken, clienttoup){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clienttopups',
            payLoad:{
                client_id:clienttoup.id,
                topupamount:clienttoup.amount
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All clientTopUps
    export async function getClientTopUps(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clienttopups',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    //Get All UnApproved clientTopUps
    export async function getUnApprovedClientTopUps(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clienttopups/indexPending',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }


//Update Client amount
export async function updateClientTopUps(userToken, clienttopup){
    const apiPayload = {
        httpMethod:'put',
        userToken,
        uri:'clienttopups/'+clienttopup.id,
        payLoad:{
            client_id:clienttopup.client_id,
            topupamount:clienttopup.topupamount
        },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}


    //Approve  clientTopUp
    export async function approveClientTopUps(userToken, clienttopup){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clienttopups/'+clienttopup.id,
            payLoad:{
                approval_status:'Approved',
                client_id:clienttopup.client_id,
                topupamount:clienttopup.topupamount,
                _method:'PUT'
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Reject  clientTopUp
    export async function rejectClientTopUps(userToken, clienttopup){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clienttopups/'+clienttopup.id,
            payLoad:{
                approval_status:'Rejected',
                client_id:clienttopup.client_id,
                _method:'PUT'
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }



  